export default {
  excess: "超额责任",
  security: "保证金",
  fuel_policy: "燃油政策",
  like_for_like: "喜欢又喜欢",
  full_to_full: "满到满",
  mileage: "里程:每次租赁 {mileage} 英里",
  unlimited_mileage: "不限里程",
  non_refundable: "不退还",
  free_cancellation_until: "免费取消直至 {date}",
  cancellation_with_terms: "取消{0}符合 ",
  t_c_text: "T&Cs",
  two_free_extras: "收藏时可免费获得两项额外奖励",
  glass_tyres_covered: "玻璃和轮胎被覆盖",
  spec_fuel_petrol: "汽油",
  spec_fuel_petrol_diesel: "汽油/柴油",
};